import { atom } from 'recoil';

export const showNavState = atom<boolean | null | undefined>({
  key: 'showNavState',
  default: true,
});

export const jukeboxActiveState = atom<boolean | null | undefined>({
  key: 'jukeboxActiveState',
  default: true,
});

export const currentBoardWidgetState = atom<boolean>({
  key: 'currentBoardWidgetState',
  default: false,
});

export const currentPageSetState = atom<{ scrollY: number; offset: number }>({
  key: 'currentPageSetState',
  default: {
    scrollY: 0,
    offset: 0,
  },
});

// 모바일 SubMenuList가 보여질 때 콘텐츠 영역에 반영할 패딩 높이 (px)
export const subMenuMobileHeightState = atom<number>({
  key: 'subMenuMobileHeightState',
  default: 0,
});

//chat
export const chatActiveState = atom<boolean | null | undefined>({
  key: 'chatActiveState',
  default: false,
});

export const chatDetailIdState = atom<string | null | undefined>({
  key: 'chatDetailIdState',
  default: '',
});
